/**
 * The administration shell — the third role.
 *
 * It is reachable by a parent, because `core-api` grants these routes to
 * parents and to nobody else. What is done here (revoking a device, purging a
 * child's data, reading the journal) is irreversible or sensitive.
 *
 * **Ce n'était pas un onglet, et ça en est un depuis le 6 septembre 2026.**
 * Hedi : *« quand j'appuie sur réglage je veux avoir des sous tabs en
 * dessous »*. La barre du haut est donc la même que partout ailleurs — un
 * onglet « Réglages » actif — et les cinq entrées d'administration descendent
 * d'un cran, dans la rangée de sous-onglets. Le lien « ← Tableau de bord »
 * disparaît avec sa raison d'être : on ne revient plus d'un autre monde, on
 * change d'onglet.
 *
 * Ce qui ne change pas : ces écrans restent groupés à l'écart du quotidien.
 * Purger les données d'un enfant ne doit pas se trouver à un doigt de travers
 * du tableau de bord.
 */

import { Outlet } from "react-router-dom";

import { ParentTopNav } from "@/parent/ParentTopNav";
import { SousOnglets } from "@/ui/SousOnglets";

const TABS = [
  { to: "/reglages", label: "Appareils", end: true },
  { to: "/reglages/sessions", label: "Sessions" },
  { to: "/reglages/notifications", label: "Notifications" },
  { to: "/reglages/journal", label: "Journal" },
  { to: "/reglages/donnees", label: "Données" },
];

export function AdminShell() {
  return (
    <div className="shell shell--admin">
      <ParentTopNav />
      <SousOnglets tabs={TABS} label="Réglages" />
      <div className="shell__body">
        <Outlet />
      </div>
    </div>
  );
}
